import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  & > *:first-child {
    min-width: 200px;
  }
`
export const Trigger = styled.div`
  display: flex;
`

export const Close = styled.div`
  background-color: rgb(255, 255, 255, 0.3);
  border-radius: 50%;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 10;
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
  padding-left: 3px;
  z-index: 50;
`

export const QrReaderContainer = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: black;
  z-index: 51;
`



// WEBPACK FOOTER //
// ./src/app/modules/QRCodeReader/styles.js